import { PrizeTypes } from "../brandVariables.types";

// Typing of the Dead (KC1005) — 2 winners per session, 3 sessions Thu/Fri/Sat
// plus 1 on Sunday (20 units total). Kept separate from keychronPrize because
// the typing-shooter board runs its own challenges with a different prize than
// the CSGO boards.
export const keychronTypingShooterPrize: PrizeTypes = {
  content: "Win a ",
  nameOf: "Keychron K6 RGB Aluminium Gateron Blue Switch", // will be marked in color
  typeOfItem: "", // will be added after nameOf

  emptyPrize:
    "https://ik.imagekit.io/gmng/keychron-kzk8f/trackerImages/Keychron_K6_FRILAGD.png",
};
